export const normalizeUrl = (url) => {
  try {
    return new URL(url, window.location.href).href;
  } catch {
    return url;
  }
};
